import React, { useEffect, useState } from "react"
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faCircleCheck, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Endpoints } from "../../../config/api";
import { AppRoutes } from "../../../config/routes";
import { langMap } from "./i18n";
import { useContext } from "react";
import LanguageContext from "../../../utils/context/i18n/languageContext";
import { errorMessages } from "../../../config/errors";
import { noAuthRequest } from "../../../utils/REST/requests";
import Header from "../../Header/Header";

const ConfirmRegistration = () => {

    const {lang} = useContext(LanguageContext);
    const [params] = useSearchParams();
    const [registered, setRegistered] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        (async ()=> {
            const code = params.get("code");
            if(code) {
                const res = await noAuthRequest("POST", Endpoints.CONFIRM_REGISTRATION, {confirmationCode: code});
                if (res.data) {
                    setError("");
                    setRegistered(true);
                }
                else {
                    setRegistered(false);
                    if(res.error)
                        setError(res.error);
                    else
                        navigate(AppRoutes.ServerError.path);
                }
            } 
            else
                setError(langMap.ProvidedCodeError[lang]);
        })();
    },[params, navigate, lang])

    return(
        <main>
            <section className="section-header bg-primary-lc text-black-lc align-items-stretch border-header" id="header">
                <Header/>
            </section>
            <section className="d-flex align-items-center mt-5 mt-lg-6 mb-lg-5">
                <Container>
                    <p className="text-center">
                        <Card.Link as={Link} to={AppRoutes.Presentation.path} className="text-gray-lc-600">
                            <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> {langMap.BackToHomepageButtonText[lang]}
                        </Card.Link>
                    </p>
                    <Col xs={12} className="d-flex align-items-center justify-content-center">
                        <div className="text-center text-md-center mb-4 mt-md-0">
                            {registered ?  
                            <>
                            <h1 className="mb-0 text-success text-secondary-lc">
                                {langMap.SuccessRegistrationTitle[lang]}
                            </h1>
                            <h4 className="secondary-text-success pt-3">
                                {langMap.SuccessRegistrationTextTop[lang]}<br/> 
                                {langMap.SuccessRegistrationTextBottom[lang]}
                            </h4>  
                            <FontAwesomeIcon icon={faCircleCheck} className="mt-6 icon-success" /> 
                            <Link as={Link} to={AppRoutes.Signin.path} className="d-flex justify-content-center align-items-center mt-6">
                                <Button variant="primary" type="submit" className="w-50">
                                    {langMap.ButtonLoginText[lang]}
                                </Button>
                            </Link>
                            </> 
                            :
                            <>
                                {
                                    error ? 
                                    <Col xs={12} className="d-flex align-items-center justify-content-center">
                                        <div className="text-center text-md-center mb-4 mt-md-0">
                                            {error.split(", ").map((err, i)=> <h3 key={"err" + i} className="mb-0 text-danger">{errorMessages[err][lang]}</h3>)}
                                            <FontAwesomeIcon icon={faCircleXmark} className="mt-6 icon-success" />
                                        </div>
                                    </Col>
                                    :
                                    <Col xs={12} className="d-flex align-items-center justify-content-center">
                                        <div className="text-center text-md-center mb-4 mt-md-0">
                                            <FontAwesomeIcon icon={faCircleCheck} className="mt-6 icon-success mb-4" />
                                            <h3 className="mb-0 text-danger">{langMap.CheckingCodeText[lang]}</h3>
                                        </div>
                                    </Col>
                                }
                            </>
                            }
                        </div>
                    </Col>  
                </Container>
            </section>
        </main>
    )

};

export default ConfirmRegistration;